import { Button, useRecordContext } from "react-admin";
import NavigationIcon from "@mui/icons-material/PinDrop";

export const LocationButton = () => {
  const record = useRecordContext();
  if (record.placeId) {
    return (
      <Button
        target="_blank"
        href={`https://www.google.com/maps/place/?q=place_id:${record.placeId}`}
        startIcon={<NavigationIcon />}
        label="Location"
      ></Button>
    );
  } else {
    return null;
  }
};
